import React from 'react'
import Popover, { PopoverProps } from 'antd/lib/popover'
import { getBEMCls } from '@/utils/classname'
import Wave from 'antd/es/_util/wave'

import './popover-confirm.scss'

export interface PopoverConfirmProps extends PopoverProps {
    types?: 'success' | 'error'
    content: string | React.ReactNode
    onConfirm?: () => void
    disabled?: boolean
    onCancel?: () => void
    styles?: React.CSSProperties
    cancelText?: string
    confirmText?: string
}

const PopoverConfirm: React.FC<PopoverConfirmProps> = props => {
    const getCls = (e?: string, m?: string) => getBEMCls('popover-confirm', e, m)

    const confirmContent = (
        <div className={getCls()} style={props.style}>
            <div className={getCls('content')}>{props.content}</div>
            <Wave>
                <div
                    className={getCls('btn', props.disabled ? 'disable' : props.types)}
                    onClick={() => {
                        if (props.disabled) return
                        props.onConfirm && props.onConfirm()
                    }}
                >
                    {props.confirmText}
                </div>
            </Wave>
            <div
                className={getCls('cancel')}
                onClick={() => {
                    props.onCancel && props.onCancel()
                }}
            >
                {props.cancelText}
            </div>
        </div>
    )

    return (
        <Popover {...props} content={confirmContent}>
            <div>{props.children}</div>
        </Popover>
    )
}

PopoverConfirm.defaultProps = {
    types: 'success',
    placement: 'bottomRight',
    confirmText: '确定',
    cancelText: '取消',
}

export default PopoverConfirm
